export const PING = "ping"
export const PONG = "pong"
export const ACTIVE = "active"
